import scheduleReports from './components/schedule_report/reducer'

const schedule = { scheduleReports }

export {
  schedule
}